/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_FailedInputs */

const cs_auth_meta_failed = /** @type {(inputs: Auth_Meta_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Meta se nezdařilo`)
};

const en_auth_meta_failed = /** @type {(inputs: Auth_Meta_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta sign-in failed`)
};

/**
* | output |
* | --- |
* | "Meta sign-in failed" |
*
* @param {Auth_Meta_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_failed = /** @type {((inputs?: Auth_Meta_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_failed(inputs)
	return cs_auth_meta_failed(inputs)
});